/*
 * Mirror Shopify's native contact-form submitter into a tagged Shopify
 * customer before allowing the normal Shopify contact POST to continue.
 * The message itself stays in Shopify's native contact workflow.
 */
(function () {
  'use strict';

  var CAPTURE_URL = 'https://portal.backcountryoffroadexpo.com/api/public/forms/shopify-contact-capture';

  function value(form, selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var field = form.querySelector(selectors[i]);
      if (field && typeof field.value === 'string' && field.value.trim()) {
        return field.value.trim();
      }
    }
    return '';
  }

  function showError(form, message) {
    var existing =
      form.querySelector('[id*="form-error"], .form__message, [data-boe-capture-error]');
    if (!existing) {
      existing = document.createElement('p');
      existing.setAttribute('data-boe-capture-error', '');
      existing.setAttribute('role', 'alert');
      existing.style.color = '#b3261e';
      form.appendChild(existing);
    }
    existing.textContent = message;
    existing.classList.remove('gp-hidden');
    existing.hidden = false;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('input[name="form_type"][value="contact"]')) return;
      if (form.dataset.boeCaptureComplete === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var email = value(form, [
        'input[name="contact[email]"]',
        'input[name="contact[Email]"]',
        'input[type="email"]'
      ]);
      var name = value(form, [
        'input[name="contact[name]"]',
        'input[name="contact[Name]"]',
        'input[autocomplete="name"]'
      ]);
      if (!name) {
        name = [
          value(form, ['input[autocomplete="given-name"]']),
          value(form, ['input[autocomplete="family-name"]'])
        ].filter(Boolean).join(' ');
      }
      var phone = value(form, [
        'input[name="contact[phone]"]',
        'input[name="contact[Phone number]"]',
        'input[type="tel"]'
      ]);

      if (!email) {
        showError(form, 'Please enter a valid email address.');
        return;
      }

      var submit = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submit) submit.disabled = true;

      fetch(CAPTURE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          name: name || undefined,
          phone: phone || undefined,
          sourcePage: window.location.href
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Shopify customer capture failed');
          form.dataset.boeCaptureComplete = 'true';
          HTMLFormElement.prototype.submit.call(form);
        })
        .catch(function () {
          showError(form, 'We could not save your details. Please try again.');
          if (submit) submit.disabled = false;
        });
    },
    true
  );
})();
